import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";

export interface ContainerData {
  /** TODO: Fill with attributes */
  placeholder: string;
}

export class ContainerDataService {
  // private httpClient = cachingHttpClient("container", 300);
  private httpClient = makeHttpClient();

  getAll() {
    return _unwrapAxiosResponse(
      this.httpClient.get<ContainerData[]>(env.containerUrl)
    );
  }

  get(id: string) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ContainerData>(`${env.containerUrl}${id}/`)
    );
  }

  update(id: string, data: ContainerData) {
    return _unwrapAxiosResponse(
      this.httpClient.put(`${env.containerUrl}${id}/`, data)
    );
  }
}

export default ContainerDataService;
